// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-controlled-module--wrapper--7b3a4"};